import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'

import Form from '../settings/Form'
import { present } from '../settings/Form/validators'
import serialize from 'form-serialize'

import HotsheetDisplayOptions from './DisplayOptions'

import AutoCompleteSearches from '../../../util/auto_complete/Searches'

@inject('websites')
@observer
export default class HotsheetForm extends Component {
  website = this.props.websites.current

  handleData = data => {
    const trimmedData = {
      ...data,
      name: (data.name && data.name.trim()) || ''
    }
    return this.props.onData(trimmedData)
  }

  createSearch = () => {
    const { router } = this.props
    const state = serialize(this.form, { hash: true })
    router.replace({
      pathname: `/website/${this.website.id}/searches/add`,
      state: { return_to: { ...router.location, state } }
    })
  }

  getAutoNext() {
    if (this.state.displayOptions === 'gallery') {
      const { defaults = {} } = this.props
      return (
        <label style={{display: 'inline'}}>
          <input type="checkbox" defaultChecked={defaults.auto_next} name="auto_next" style={{display: 'inline', width: 'auto', marginLeft: '20px', marginRight: '5px'}} />
          Automatically Scroll Results
        </label>
      )
    }
  }

  render() {
    const { defaults={} } = this.props

    const validations = [
      { field: 'search_id', validate: present, message: 'Please Select a Search' },
      { field: 'name', validate: present, message: 'Please Enter a Name' },
      { field: 'display_options', validate: present, message: 'Please choose a display option' }
    ]
    return (
      <Form ref={el => this.form = el && el.form} className="full" onData={this.handleData} validations={validations}>
        <div className="panel padded">
          <h2 className="title">New Hotsheet</h2>

          <div className="form-section">
            <label htmlFor="name">Hotsheet Name</label>
            <p className="muted">The name will be used when embedding the hotsheet into the website.</p>
            <input name="name" id="name" placeholder="Enter a Name" defaultValue={defaults.name} />
          </div>

          <div className="form-section">
            <label>Search</label>
            <p className="muted">The hotsheet will show listings from this search.</p>
            <AutoCompleteSearches
              name="search_id"
              id="search_id"
              selected={defaults.search_id}
              onCreateNew={this.createSearch} />
          </div>

          <div className="form-section">
            <label htmlFor="display_options">Display Options</label>
            <p className="mute">How the results will be displayed on the hotsheet.</p>
            <HotsheetDisplayOptions name="display_options" defaultSelected={defaults.display_options} autoNext={defaults.auto_next} />
          </div>

          <div className="form-section">
            <label htmlFor="results_limit">Limit Results</label>
            <p className="mute">How many results will be displayed on the hotsheet.</p>
            <select id="results_limit" name="results_limit" defaultValue={defaults.results_limit || 20}>
              <option value="4">4</option>
              <option value="8">8</option>
              <option value="20">20</option>
              <option value="60">60</option>
            </select>
          </div>

          <div className="form-section">
            <label htmlFor="link_to_full">Link To Full Results</label>
            <p className="mute">Show a link to the default search page with this search loaded.</p>
            <select id="link_to_full" name="link_to_full" defaultValue={defaults.link_to_full}>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
          </div>

          <div className="form-section">
            <label htmlFor="display_options">Custom "See All Results" Button Text</label>
            <p className="mute">Change the wording on the buttons at the bottom of the results</p>
            <input name="see_more_text" id="see_more_text" placeholder="See All Results" defaultValue={defaults.see_more_text} />
          </div>

          <div className="form-section">
            <label htmlFor="show_map">Show Map</label>
            <p className="mute">Include the search map in this hotsheet.</p>
            <select id="show_map" name="show_map" defaultValue={defaults.show_map}>
              <option value="false">No</option>
              <option value="true">Yes</option>
            </select>
          </div>

          <input type="hidden" name="website_id" value={this.website.id} />

        </div>
        <button type="submit" className="big shadowed">{this.props.submit || 'Save'}</button>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/Hotsheets/Form.js